import React from 'react';
import styled, { keyframes } from 'styled-components';
import {
    LoaderContainer,
    SpinnerWrapper,
    Spinner,
    LoadingText,
    SmallSpinnerWrapper,
    SmallLoaderContainer,
    LoaderOverlay
} from '../styles/Loader.styles';


function Loader({ text = 'Loading...', fullScreen = false, small = false, overlay = false }) {
    const Content = (
        <>
            <SpinnerWrapper>
                <Spinner />
            </SpinnerWrapper>
            {text && <LoadingText>{text}</LoadingText>}
        </>
    );

    if (overlay) {
        return <LoaderOverlay>{Content}</LoaderOverlay>;
    }

    if (small) {
        return (
            <SmallLoaderContainer fullScreen={fullScreen}>
                <SmallSpinnerWrapper>
                    <Spinner />
                </SmallSpinnerWrapper>
                {text && <LoadingText>{text}</LoadingText>}
            </SmallLoaderContainer>
        );
    }

    return (
        <LoaderContainer fullScreen={fullScreen}>
            <SpinnerWrapper>
                <Spinner />
            </SpinnerWrapper>
            {text && <LoadingText>{text}</LoadingText>}
        </LoaderContainer>
    );
}

export default Loader;
